import "core-js/modules/es.error.cause.js";
//js文件
import { initI18n } from '@/utils/i18n';

// 注册i18n实例并引入语言文件，文件格式等下解析
var i18n = initI18n('CN', 'US');
export var lineParamsList = [{
  id: 1,
  type: 'input',
  title: true,
  name: 'Channel ID',
  titleName: 'Line Login',
  prop: 'appId',
  disabled: false
}, {
  id: 2,
  type: 'input',
  name: 'Channel Secret',
  prop: 'appSecret',
  disabled: false
}, {
  id: 3,
  type: 'input2',
  name: 'Callback URL：',
  disabled: true,
  prop: 'url',
  row: 2
}, {
  id: 4,
  type: 'input',
  title: true,
  name: 'Channel access token',
  titleName: 'Message Api',
  errorContent: '111',
  prop: 'nfToken',
  disabled: false
}];
export var wxParamsList = [{
  id: 5,
  type: 'input',
  title: true,
  icon: true,
  name: 'App ID',
  titleName: i18n.t("systemsetting.basicsetting.socialLogin.wxName1"),
  prop: 'appid',
  disabled: false,
  iconContent: i18n.t("systemsetting.basicsetting.socialLogin.wxParams1")
}, {
  id: 6,
  type: 'input',
  name: 'Secret',
  prop: 'Secret',
  disabled: false
}, {
  id: 7,
  type: 'input',
  title: true,
  icon: true,
  name: 'App ID',
  titleName: i18n.t("systemsetting.basicsetting.socialLogin.wxName2"),
  prop: 'appid2',
  disabled: false,
  iconContent: i18n.t("systemsetting.basicsetting.socialLogin.wxParams2")
}, {
  id: 8,
  type: 'input',
  name: 'Secret',
  prop: 'Secret2',
  disabled: false
}, {
  id: 9,
  type: 'input',
  title: true,
  icon: true,
  name: 'App ID',
  titleName: i18n.t("systemsetting.basicsetting.socialLogin.wxName3"),
  prop: 'appid3',
  disabled: false,
  iconContent: i18n.t("systemsetting.basicsetting.socialLogin.wxParams2")
}, {
  id: 10,
  type: 'input',
  name: 'Secret',
  prop: 'Secret3',
  disabled: false
}, {
  id: 11,
  type: 'input',
  title: true,
  icon: true,
  name: 'App ID',
  titleName: i18n.t("systemsetting.basicsetting.socialLogin.wxName4"),
  prop: 'appid4',
  disabled: false,
  iconContent: i18n.t("systemsetting.basicsetting.socialLogin.wxParams3")
}, {
  id: 12,
  type: 'input',
  name: 'Secret',
  prop: 'Secret4',
  disabled: false
}];
export var qqParamsList = [{
  id: 13,
  type: 'input',
  name: 'App ID',
  prop: 'appId',
  disabled: false
}, {
  id: 14,
  type: 'input',
  name: 'App Key',
  prop: 'appSecret',
  disabled: false
}, {
  id: 15,
  type: 'input2',
  name: 'Callback URL：',
  disabled: true,
  prop: 'url',
  row: 1
}];
export var wbParamsList = [{
  type: 'input',
  name: 'App Key',
  prop: 'appId',
  disabled: false
}, {
  type: 'input',
  name: 'App Serect',
  prop: 'appSecret',
  disabled: false
}];
export var fbParamsList = [{
  type: 'input',
  name: 'App ID',
  prop: 'appId',
  disabled: false
}];
var checkToken = function checkToken(rule, value, callback) {
  if (value == '') {
    return callback(new Error('若要打开Line消息通知，请填写Channel access token'));
  } else {
    return callback();
  }
};
export var lineRules = {
  id: [{
    required: true,
    message: '请输入Channel ID',
    trigger: 'blur'
  }],
  Secret: [{
    required: true,
    message: '请输入Channel Secret',
    trigger: 'blur'
  }],
  token: [{
    validator: checkToken,
    trigger: 'change'
  }]
};
export var wxRules = {
  appid: [{
    required: true,
    message: '请输入App ID',
    trigger: 'blur'
  }],
  Secret: [{
    required: true,
    message: '请输入Secret',
    trigger: 'blur'
  }],
  appid2: [{
    required: true,
    message: '请输入App ID',
    trigger: 'blur'
  }],
  Secret2: [{
    required: true,
    message: '请输入Secret',
    trigger: 'blur'
  }],
  appid3: [{
    required: true,
    message: '请输入App ID',
    trigger: 'blur'
  }],
  Secret3: [{
    required: true,
    message: '请输入Secret',
    trigger: 'blur'
  }]
};
export var qqRules = {
  appid: [{
    required: true,
    message: '请输入App ID',
    trigger: 'blur'
  }],
  appkey: [{
    required: true,
    message: '请输入App Key',
    trigger: 'blur'
  }]
};
export var wbRules = {
  appkey: [{
    required: true,
    message: '请输入App Key',
    trigger: 'blur'
  }],
  appSerect: [{
    required: true,
    message: '请输入App Serect',
    trigger: 'blur'
  }]
};
export var fbRules = {
  appid: [{
    required: true,
    message: '请输入App ID',
    trigger: 'blur'
  }]
};